import { Division } from '../types';

export function DivisionCard(division: Division): string {
  const highlightsHtml = division.highlights.map(hl => /*html*/`
    <li style="display: flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; color: #cbd5e1;">
      <span style="color: ${division.themeColor}; font-size: 0.9rem;">✓</span>
      <span>${hl}</span>
    </li>
  `).join('');

  return /*html*/`
    <div class="glass-panel" style="display: flex; flex-direction: column; overflow: hidden; height: 100%; border-top: 3px solid ${division.themeColor};">
      
      <!-- Card Image Preview -->
      <div style="position: relative; height: 190px; overflow: hidden; background: #07080d;">
        <img 
          src="${division.bannerImage}" 
          alt="${division.title}" 
          style="width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease;"
          onmouseover="this.style.transform='scale(1.05)'"
          onmouseout="this.style.transform='scale(1.0)'"
          onerror="this.src='/images/brand/atomixm-hero-banner.jpg'"
        />
        <div style="position: absolute; inset: 0; background: linear-gradient(180deg, transparent 40%, rgba(18, 21, 33, 0.95) 100%);"></div>
        <div style="position: absolute; bottom: 1rem; left: 1.25rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="width: 32px; height: 32px; border-radius: 8px; background: ${division.themeColor}; display: flex; align-items: center; justify-content: center; color: #07080d;">
            <sl-icon name="${division.icon}" style="font-size: 1.2rem;"></sl-icon>
          </div>
          <span style="font-size: 1.2rem; font-weight: 800; color: #ffffff;">${division.title}</span>
        </div>
      </div>

      <!-- Card Body -->
      <div style="padding: 1.5rem; display: flex; flex-direction: column; flex-grow: 1; justify-content: space-between;">
        <div>
          <div style="font-size: 0.85rem; font-weight: 600; color: ${division.themeColor}; margin-bottom: 0.5rem; text-transform: uppercase; letter-spacing: 0.05em;">
            ${division.tagline}
          </div>
          <p style="font-size: 0.92rem; color: #94a3b8; line-height: 1.55; margin-bottom: 1.25rem;">
            ${division.description}
          </p>

          <!-- Key Highlights -->
          <ul style="list-style: none; padding: 0; display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1.5rem; background: rgba(0,0,0,0.25); padding: 0.85rem; border-radius: 8px;">
            ${highlightsHtml}
          </ul>
        </div>

        <!-- Card Footer Link -->
        <div style="display: flex; justify-content: space-between; align-items: center; border-top: 1px solid rgba(255,255,255,0.06); padding-top: 1rem;">
          <a href="${division.route}" class="btn-cyber" style="background: ${division.accentGradient}; padding: 0.5rem 1rem; font-size: 0.85rem; width: 100%;">
            <span>Enter ${division.title}</span>
            <sl-icon name="arrow-right"></sl-icon>
          </a>
        </div>
      </div>

    </div>
  `;
}
